import axios from 'axios'
import app from '../main'


export default function setup () {
  axios.interceptors.request.use(
    config => {
      app.$vs.loading()
      return config
    },
    async error => {
      app.$vs.loading.close()
      
      if (error.response && error.response.status === 401) {
        await app.$auth.logout({
          redirect: '/login',
          makeRequest: false
        })
      }
      
      return Promise.reject(error)
    }
  )
  
  axios.interceptors.response.use(
    response => {
      app.$vs.loading.close()
      return response
    },
    async error => {
      app.$vs.loading.close()
      
      if (error.response) {
        
        switch (error.response.status) {
          case 401 :
            await app.$auth.logout({
              redirect: '/login',
              makeRequest: false
            })
            break
          case 404 :
            await app.$router.push('/404')
            break
        }
        
        let err = error.response
        
        app.$vs.notify({
          title: err.statusText + ' ' + err.status,
          text: err.data,
          color: 'danger',
          icon: 'error_outline',
          time: 5000
        })
        
      }
      
      return Promise.reject(error)
    }
  )
}
